import React from 'react';
import { uniqueId } from 'lodash';

const CAT_TYPE = 'category';
const SUB_CAT_TYPE = 'subcategory';
const DISPLAY = 'display';

class MenuList extends React.Component {
  initialState(props) {
    return {
      restaurantMenu: props.restaurantMenu || {},
      show: 0,
      hideCurrent: false,
    };
  }

  constructor(props) {
    super(props);
    this.isActive = this.isActive.bind(this);
    this.show = this.show.bind(this);
    this.handleOnClick = this.handleOnClick.bind(this);
    this.state = this.initialState(props);
  }

  componentWillMount() {
    const filterRestaurantMenu = menuItems => {
      const m = [];
      if (menuItems.menu_category) {
        menuItems.menu_category.map(function(item) {
          if (Number(item.parentid) === -1) {
            m[item.id] = item;
            m[item.id]['children'] = [];
          } else if (m[item.parentid]) {
            m[item.parentid]['children'].push(item);
          }
        });

        menuItems.universal_category.map(function(item) {
          m.map(function(category, key) {
            if (category) {
              item.text = item.name;
              m[key]['children'].push(item);
            }
          });
        });
        return m;
      } else {
        return m;
      }
    };
    this.setState({
      restaurantMenu: filterRestaurantMenu(this.state.restaurantMenu),
    });
  }

  handleOnClick(data, categoryId) {
    this.props.onSelect(data, categoryId);
  }

  show(categoryId) {
    const intCatId = Number(categoryId);
    this.setState({
      show: intCatId,
      hideCurrent:
        intCatId === this.state.show ? !this.state.hideCurrent : false,
    });
  }

  isActive(type, id) {
    const intId = Number(id);
    const activeCategory = Number(this.props.activeCategory);
    const activeSubCategory = Number(this.props.activeSubCategory);
    const onActivePage = 'dashboard';

    switch (type) {
      case CAT_TYPE:
        return (
          activeCategory === intId &&
          (this.state.show === 0 || activeCategory === this.state.show) &&
          !this.state.hideCurrent &&
          this.props.page === onActivePage
        );
      case DISPLAY:
        return intId === this.state.show && !this.state.hideCurrent;
      default:
        return activeSubCategory === intId && this.props.page === onActivePage;
    }
  }

  render() {
    return (
      <ul>
        {this.state.restaurantMenu.map(categories => {
          return (
            <li
              key={uniqueId('parent-')}
              className={
                this.isActive(CAT_TYPE, categories.id)
                  ? 'active-menu'
                  : this.isActive(DISPLAY, categories.id) ? 'show' : ''
              }
            >
              <a
                href="javascript:void(0);"
                onClick={e => this.show(categories.id)}
                className="olo-client-theme-color"
              >
                {categories.text}
                <span className="pull-right">
                  <i className="fa fa-chevron-down" />
                </span>
              </a>
              <ul key={uniqueId('child-parent-')}>
                {categories.children.map(subCategories => {
                  return (
                    <li
                      className={
                        this.isActive(SUB_CAT_TYPE, subCategories.id)
                          ? 'active-sub-menu'
                          : ''
                      }
                      key={uniqueId('child-')}
                    >
                      <a
                        href="javascript:void(0);"
                        onClick={e =>
                          this.handleOnClick(subCategories, categories.id)
                        }
                        className="olo-client-theme-color"
                      >
                        {subCategories.text}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default MenuList;



// WEBPACK FOOTER //
// ./src/views/menu/components/MenuList.jsx